import { useTranslation } from 'next-i18next';

/**
 * ko/ja locale에서는 OX 아이콘(동그라미/엑스)을,
 * 그 외 locale에서는 True/False 아이콘(체크/엑스)을 사용해야 하는지 판단.
 * @returns true면 OX locale, false면 True/False locale
 */
export function useIsOXLocale(): boolean {
  const { i18n } = useTranslation();
  const lang = i18n.language ?? '';
  return lang.startsWith('ko') || lang.startsWith('ja');
}
